/** @jsxImportSource @emotion/react */

import '@splidejs/react-splide/css';

import { useLingui } from '@lingui/react/macro';
import { Options, Splide, SplideSlide } from '@splidejs/react-splide';
import React from 'react';

import { galleryStyles } from './styles';
import { GalleryImage } from './types';

interface ImageGalleryProps {
  images: GalleryImage[];
  currentIndex: number;
  onClose: () => void;
  options?: Options;
  style?: React.CSSProperties;
}

export const ImageGallery: React.FC<ImageGalleryProps> = ({ images, currentIndex, onClose, options, style }) => {
  const { t } = useLingui();

  return (
    <div css={galleryStyles.container}>
      <Splide
        options={{
          start: currentIndex,
          perPage: 1,
          arrows: images.length > 1,
          pagination: true,
          height: '60vh',
          cover: true,
          heightRatio: 0.5,
          focus: 'center',
          keyboard: 'global',
          drag: images.length > 1,
          wheel: false,
          ...options,
        }}
        style={style}
      >
        {images.map((img, index) => {
          const number = index + 1;

          return (
            <SplideSlide key={index}>
              <div css={galleryStyles.slideContainer}>
                <img src={img.url || img.externalUrl} alt={t`Изображение ${number}`} css={galleryStyles.image} />
              </div>
            </SplideSlide>
          );
        })}
      </Splide>
    </div>
  );
};
